module.exports = __webpack_public_path__ + "img/qr-eps.34276eb8.svg";